import { ReactNode } from "react";

type TextNoTranformProps = {
  children: ReactNode;
};
export const TextNoTranform = ({ children }: TextNoTranformProps) => {
  return <span style={{ textTransform: "none" }}>{children}</span>;
};
